import { render } from "./CategoryPage.vue?vue&type=template&id=15a4cf60&scoped=true&ts=true"
import script from "./CategoryPage.vue?vue&type=script&lang=ts"
export * from "./CategoryPage.vue?vue&type=script&lang=ts"

import "./CategoryPage.vue?vue&type=style&index=0&id=15a4cf60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a4cf60"]])

export default __exports__